export function formatDate(iso) {
  if (!iso) return "—";
  const d = typeof iso === "string" ? new Date(iso) : iso;
  if (isNaN(d.getTime())) return "—";
  return d.toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
}

export function formatDateTime(ts) {
  if (!ts) return "—";
  const d = new Date(ts);
  return d.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" })
    + ", "
    + d.toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit", hour12: false });
}

export function formatCurrency(n) {
  if (n == null) return "—";
  return `₹${Number(n).toLocaleString("en-IN", { maximumFractionDigits: 0 })}`;
}

export function daysUntil(iso) {
  if (!iso) return 0;
  const d = new Date(iso);
  const diff = d.getTime() - Date.now();
  return Math.ceil(diff / (1000 * 60 * 60 * 24));
}

export function segmentColor(segment) {
  switch (segment) {
    case "New":
      return "bg-[#9D00FF]/15 text-[#D78CFF] border-[#9D00FF]/40";
    case "Regular":
      return "bg-emerald-500/15 text-emerald-300 border-emerald-500/40";
    case "At Risk":
      return "bg-[#F59E0B]/15 text-[#F59E0B] border-[#F59E0B]/40";
    case "Lost":
      return "bg-[#EF4444]/15 text-[#EF4444] border-[#EF4444]/40";
    default:
      return "bg-white/10 text-white border-white/20";
  }
}

export function statusColor(status) {
  switch (status) {
    case "Active":
      return "bg-[#9D00FF]/15 text-[#D78CFF] border-[#9D00FF]/50";
    case "Expiring Soon":
      return "bg-[#F59E0B]/15 text-[#F59E0B] border-[#F59E0B]/50";
    case "Expired":
      return "bg-[#EF4444]/15 text-[#EF4444] border-[#EF4444]/50";
    default:
      return "bg-white/10 text-white border-white/20";
  }
}
